export function updateHeapPageId(page: { id: string }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageIdAvailable',
    pageId: page.id,
  });
}



// WEBPACK FOOTER //
// ./src/helpers/heap.ts